import {Component} from '@angular/core';
import {TranslateService as TranslateProvider} from '@ngx-translate/core';
import {AnalyticsConfiguration, AnalyticsService, APP_CONFIG, TranslateService} from '@gallaghercp/core-frontend';
import {MatSnackBar} from '@angular/material/snack-bar';
import {SwUpdate, VersionEvent} from '@angular/service-worker';

@Component({
    selector: 'core-root',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class AppComponent {
    title: string = 'core-archipelago';

    constructor(
        private translate: TranslateService,
        private translateProvider: TranslateProvider,
        private analytics: AnalyticsService,
        private updates: SwUpdate,
        private snackBar: MatSnackBar,
    ) {
        this.analytics.initialise(({
            gtm: {id: APP_CONFIG.gtm, consent: 3},
        } as AnalyticsConfiguration));

        if (APP_CONFIG.multilingual) {
            this.translateProvider.setDefaultLang(translate.getDefaultLanguage());
            this.translate.getLanguages().subscribe((languages: any) => {
                this.translateProvider.addLangs(
                    languages.map((language: any) => {
                        return language.code;
                    })
                );
            });
        }

        if (this.updates.isEnabled) {
            this.updates.versionUpdates.subscribe((evt: VersionEvent) => {
                switch (evt.type) {
                    case 'VERSION_DETECTED':
                        console.log(`Downloading new app version: ${evt.version.hash}`);
                        break;
                    case 'VERSION_READY':
                        console.log(`Current app version: ${evt.currentVersion?.hash}`);
                        console.log(`New app version ready for use: ${evt.latestVersion.hash}`);
                        this.promptUser();  // Prompt the user to refresh
                        break;
                    case 'VERSION_INSTALLATION_FAILED':
                        console.log(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
                        break;
                }
            });
        }
    }

    promptUser(): void {
        const snackBarRef = this.snackBar.open('A new version of SOLV Total Rewards is available', 'Refresh');
        snackBarRef.onAction().subscribe(() => {
            window.location.reload();
        });
    }

}
